import React from "react";
import {
  CircularProgress,
  IconButton,
  Input,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import BluetoothSpeakerCalibrationRow from "./bluetooth-speaker-calibration-row";

const HEADERS = [
  "Godzina",
  "Data",
  "Głośnik BT",
  "Model telefonu",
  "Marka",
  "Producent",
  "Device ID",
  "Kalibrator",
  "Notatki",
  "Odsłuchy",
  "Opcje",
];

function FilterInput({ value, onInput }) {
  return <Input value={value} onInput={onInput} />;
}

export default function BluetoothSpeakerCalibrationTable({
  rowData,
  page,
  rowsPerPage,
  count,
  inputHandler,
  filters,
  handleChangePage,
  handleChangeRowsPerPage,
  isDetailedData,
  loading,
  updateData,
  removeHandler,
}) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography>{HEADERS[0]}</Typography>
            </TableCell>

            <TableCell>
              <Typography>{HEADERS[1]}</Typography>
              <TextField
                id="bluetooth-speaker-date"
                type="date"
                value={filters.date}
                onInput={(event) => inputHandler(event, "date")}
              />
              {filters.date ? (
                <IconButton
                  onClick={() => inputHandler(null, "date", true)}
                  size="small"
                >
                  <ClearIcon />
                </IconButton>
              ) : null}
            </TableCell>

            <TableCell>
              <Typography>{HEADERS[2]}</Typography>
              <FilterInput
                value={filters.speakerModel}
                onInput={(event) => inputHandler(event, "speakerModel")}
              />
            </TableCell>

            <TableCell>
              <Typography>{HEADERS[3]}</Typography>
              <FilterInput
                value={filters.model}
                onInput={(event) => inputHandler(event, "model")}
              />
            </TableCell>

            <TableCell>
              <Typography>{HEADERS[4]}</Typography>
              <FilterInput
                value={filters.brand}
                onInput={(event) => inputHandler(event, "brand")}
              />
            </TableCell>

            <TableCell>
              <Typography>{HEADERS[5]}</Typography>
              <FilterInput
                value={filters.manufacturer}
                onInput={(event) => inputHandler(event, "manufacturer")}
              />
            </TableCell>

            <TableCell>
              <Typography>{HEADERS[6]}</Typography>
              <FilterInput
                value={filters.deviceId}
                onInput={(event) => inputHandler(event, "deviceId")}
              />
            </TableCell>

            <TableCell>
              <Typography>{HEADERS[7]}</Typography>
              <FilterInput
                value={filters.calibrator}
                onInput={(event) => inputHandler(event, "calibrator")}
              />
            </TableCell>

            <TableCell>
              <Typography>{HEADERS[8]}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{HEADERS[9]}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{HEADERS[10]}</Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {loading && rowData.length === 0 ? (
            <TableRow>
              <TableCell colSpan={HEADERS.length} align="center">
                <CircularProgress size={28} />
              </TableCell>
            </TableRow>
          ) : null}

          {!loading && rowData.length === 0 ? (
            <TableRow>
              <TableCell colSpan={HEADERS.length} align="center">
                Brak kalibracji głośników BT.
              </TableCell>
            </TableRow>
          ) : null}

          {rowData.map((item) => (
            <BluetoothSpeakerCalibrationRow
              key={item.id}
              rowData={item}
              isDetailedData={isDetailedData}
              updateData={updateData}
              columnCount={HEADERS.length}
              removeHandler={removeHandler}
            />
          ))}
        </TableBody>

        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[10, 20, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              count={count}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage="liczba kalibracji na stronę"
              labelDisplayedRows={({ from, to, count: totalCount }) =>
                `${from}-${to} z ${totalCount}`
              }
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
